export default {
  "CTA": "_CTA_npxx0_3"
};import "ni:sha-256;QMFbsvONmqCOrHS6ZZ3jNfzRCFtYbW2a6dSu-4PttaM";